import moment from "moment-timezone";

const timeFormat = (m) => {
    const fakeTimeFormat = 12;
    return fakeTimeFormat === 12 ? "h:mm A" : "HH:mm";
};

const formats = [
    { name: "standard", format: "MMM D YYYY", formatNoYear: "MMM D" },
    { name: "extended", format: "dddd, MMMM Do YYYY", formatNoYear: "dddd, MMMM Do" },
    { name: "standard", format: "MMM D YYYY", formatNoYear: "MMM D" },
];

const getFormat = (name, omityear, time) => {
    const df = formats.find((f) => {
        return f.name === name;
    });
    let format = omityear ? df.formatNoYear : df.format;
    if (time) {
        format += " " + timeFormat();
    }
    return format;
};

const parse = (momentdate, style, showyearalways) => {
    const omityear = showyearalways ? false : momentdate.year() === moment().year();
    switch (style) {
        case "log":
            return momentdate.format(getFormat("standard", omityear, true));
        case "notime":
            return momentdate.format(getFormat("standard", omityear, false));
        case "ext":
            return momentdate.format(getFormat("extended", omityear, true));
        case "ext-notime":
            return momentdate.format(getFormat("extended", omityear, false));
        default:
            return momentdate.format(getFormat("standard", omityear, true));
    }
};

const showDate = (date, style) => {
    const m = moment.utc(date);
    if (m.isValid) {
        return parse(m, style || "");
    } else {
        return "n.d.";
    }
};

const showDateNoTime = (date) => {
    const m = moment.utc(date);
    if (m.isValid()) {
        return parse(m, "notime");
    } else {
        return "n.d.";
    }
};

const showTime = (date) => {
    const m = moment.utc(date);
    if (m.isValid()) {
        return m.format(timeFormat(m));
    } else {
        return "n.d.";
    }
};

const getNow = () => moment.utc();

const isToday = (ldate) => getNow().isSame(ldate, "day");

const showDateLongFormat = (date) => {
    return moment.utc(date).format("ddd, MMMM DD");
};

const calculateAge = (date) => {
    const m = moment(date);
    if (m.isValid() && m.isBefore(moment())) {
        return moment().diff(m, "years");
    }
    return null;
};

export { showDate, showDateNoTime, showTime, isToday, showDateLongFormat, calculateAge };
